import Table from './Table'
import Column from './Column'

export { Table, Column }
export default Table
